import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLine14 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
			fill: "#640082"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M20.7888 15.9326V13.8678H19.1558V5.44019H15.7773L10.6345 13.4737V15.9326H16.6035V18.6918H19.1561V15.9326H20.7888ZM9.1812 5.44019V18.6918H6.36589V8.27427C5.91511 8.63088 4.58259 9.32532 4.0945 9.56949L3.40007 9.9261L2.49902 7.89888L3.30589 7.52375C4.84502 6.79175 6.27172 5.90949 6.87224 5.44019H9.1812ZM16.6035 7.7674V13.8678H12.9059L15.6088 9.62584C16.1342 8.79993 16.5095 7.99279 16.5656 7.7674H16.6035Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgLine14);
export { ForwardRef as ReactComponent };
